export const Types = {
  REQUEST: 'signup/REQUEST',
  ERROR: 'signup/ERROR',
};

const INITIAL_STATE = { loading: false };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.REQUEST:
      return { loading: true };
    case Types.ERROR:
      return { loading: false };
    default:
      return state;
  }
};

export const Creators = {
  signup: (nickname, email, password, mkt, voucher) => ({
    type: Types.REQUEST,
    payload: {
      customer: {
        nickname,
        email,
        password,
        mkt,
      },
      voucher,
    },
  }),
  signupError: () => ({ type: Types.ERROR }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/signup.js